import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  salary_advances: [],
  error: null,
  message: '',
};

const SalaryAdvances = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_SALARY_ADVANCES_REQUEST:
    case actionTypes.DELETE_SALARY_ADVANCES_REQUEST:
    case actionTypes.UPLOAD_SALARY_ADVANCES_REQUEST:
    case actionTypes.MULTIDELETE_SALARY_ADVANCES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPDATE_SALARY_ADVANCES_SUCCESS:
    case actionTypes.DELETE_SALARY_ADVANCES_SUCCESS:
    case actionTypes.UPLOAD_SALARY_ADVANCES_SUCCESS:
    case actionTypes.MULTIDELETE_SALARY_ADVANCES_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case actionTypes.GET_SALARY_ADVANCES_SUCCESS:
      return {
        ...state,
        loading: false,
        salary_advances: action.payload,

      }
    case actionTypes.GET_SALARY_ADVANCES_FAILURE:
    case actionTypes.UPDATE_SALARY_ADVANCES_FAILURE:
    case actionTypes.DELETE_SALARY_ADVANCES_FAILURE:
    case actionTypes.UPLOAD_SALARY_ADVANCES_FAILURE:
    case actionTypes.MULTIDELETE_SALARY_ADVANCES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default SalaryAdvances
